export default "__VITE_ASSET__8242b1a3__"